import { useState, useEffect } from "react";
import "./CandidateTable.css";

const formatTestScore = (score, maxScore) => {
  if (score == null || maxScore == null || maxScore === 0) return "-";
  const percent = ((score / maxScore) * 100).toFixed(1);
  return `${score} / ${maxScore} (${percent}%)`;
};

const CandidateTable = ({ sortedCandidates, onSelectionChange, loading, testMaxScore }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    onSelectionChange(selectedIds);
  }, [selectedIds, onSelectionChange]);

  const toggleSelection = (candidateId) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(candidateId)
        ? prevSelected.filter((id) => id !== candidateId)
        : [...prevSelected, candidateId]
    );
  };

  const isAllSelected =
    sortedCandidates.length > 0 &&
    sortedCandidates.every((c) => selectedIds.includes(c.id));

  const handleSelectAllChange = () => {
    if (isAllSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(sortedCandidates.map((c) => c.id));
    }
  };

  return (
    <div className="table-container">
      {loading ? (
        <div className="loading-message">Loading candidates...</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                />
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>Matching Score</th>
              <th>Reason</th>
              <th>AI Score</th>
              <th>Evaluated At</th>
              <th>Test Status</th>
              <th>Test Score</th>
              <th>Application Code</th>
              <th>Un-focus</th>
            </tr>
          </thead>
          <tbody>
            {sortedCandidates.map((c) => {
              const isChecked = selectedIds.includes(c.id);
              return (
                <tr
                  key={c.id}
                  className={isChecked ? "row-selected" : ""}
                  onClick={() => toggleSelection(c.id)}
                >
                  <td>
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      checked={isChecked}
                      onChange={() => toggleSelection(c.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                  <td>{c.full_name}</td>
                  <td>{c.email}</td>
                  <td>{c.score ?? "-"}</td>
                  <td>{c.reasoning ?? "-"}</td>
                  <td>{c.cv_ai_score ?? "-"}</td>
                  <td>{c.evaluated_at ?? "-"}</td>
                  <td>
                    <span className={`test-status status-${c.test_status || "none"}`}>
                      {c.test_status || "none"}
                    </span>
                  </td>
                  <td className="col-test-score">
                    {c.test_status === "completed"
                      ? formatTestScore(c.test_total_score, c.test_question_count)
                      : "-"}
                  </td>
                  <td className="application-code">
                    {c.application_code ?? "-"}
                  </td>
                  <td>{c.test_unfocus_count ?? 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CandidateTable;
